export default function() {
  var nodes = [];
  this.each(function(node) {
    nodes.push(node);
  });
  return nodes;
}



//////////////////
// WEBPACK FOOTER
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/~/d3-hierarchy/src/hierarchy/descendants.js
// module id = ../../../../d3-hierarchy/src/hierarchy/descendants.js
// module chunks = 4